import { computed } from 'vue';
import useRwdImg from '@/hooks/useRwdImg';

const bgComic = computed(() => useRwdImg('anniversary_pc_bg_comic'));
const bgComicReader = computed(() => useRwdImg('anniversary_pc_bg_comic_reader'));
const bgComicInfo = computed(() => useRwdImg('anniversary_pc_bg_comic_info'));
const bgStatusDisable = computed(() => useRwdImg('anniversary_pc_bg_status_disable'));
const btn = computed(() => useRwdImg('anniversary_pc_btn'));
const iconArrowDown = computed(() => useRwdImg('anniversary_pc_icon_arrow_down'));
const iconBack = computed(() => useRwdImg('anniversary_pc_icon_back'));
const iconBackActive = computed(() => useRwdImg('anniversary_pc_icon_back_active'));
const imgComicFrame = computed(() => useRwdImg('anniversary_pc_img_comic_frame'));
const imgComicTitle = computed(() => useRwdImg('anniversary_pc_img_comic_title'));

export function useBackgroundUrl() {
  return {
    bgComic: bgComic.value.backgroundUrl,
    bgComicReader: bgComicReader.value.backgroundUrl,
    bgComicInfo: bgComicInfo.value.backgroundUrl,
    bgStatusDisable: bgStatusDisable.value.backgroundUrl,
    btn: btn.value.backgroundUrl,
    iconArrowDown: iconArrowDown.value.backgroundUrl,
    iconBack: iconBack.value.backgroundUrl,
    iconBackActive: iconBackActive.value.backgroundUrl,
    imgComicFrame: imgComicFrame.value.backgroundUrl,
    imgComicTitle: imgComicTitle.value.backgroundUrl,
  }
}

export function useImgSrc() {
  return {
    bgComic: bgComic.value.imgSrc,
    bgComicReader: bgComicReader.value.imgSrc,
    bgComicInfo: bgComicInfo.value.imgSrc,
    bgStatusDisable: bgStatusDisable.value.imgSrc,
    btn: btn.value.imgSrc,
    iconArrowDown: iconArrowDown.value.imgSrc,
    iconBack: iconBack.value.imgSrc,
    iconBackActive: iconBackActive.value.imgSrc,
    imgComicFrame: imgComicFrame.value.imgSrc,
    imgComicTitle: imgComicTitle.value.imgSrc,
  }
}
